import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { PecComunicazioneVO } from 'shell/models/pec';
import { DateTime } from 'luxon';
import { PecForm } from '../form';
import { TypeFile } from 'practice/components/detail/form/accordion-attachments/form';

export const transformPec = (
  response: AxiosResponse<HttpResponse<PecComunicazioneVO>>
): PecForm => {
  const data = response.data.payload.pecComunicazioneVOList
    ? response.data.payload.pecComunicazioneVOList[0]
    : {};

  return {
    data,
    oldCode: response.data.payload.datiComunicazioneVO?.idPecOrigine,
    code: data.key?.idComunicazione,
    sender: data.mittente || '',
    receiver: data.pecDestinatarioVOList?.map((el) => el.key.destinatario).join(' ') || '',
    descRecipient:
      data.pecDestinatarioVOList?.map((el) => el.descrizioneDestinatario).join(' ') || '',
    subject: data.oggetto || '',
    messageBody: data.corpo || '',
    messageDate: data.timestampInserimento
      ? DateTime.fromISO(data.timestampInserimento).toFormat('dd/MM/yyyy - HH:mm')
      : '',
    cc: '',
    sendDate: data.timestampInvio
      ? DateTime.fromISO(data.timestampInvio).toFormat('dd/MM/yyyy - HH:mm')
      : '',
    processingStatus: data.codiceStato,
    messageId: data.idMessaggio || '',
    transmissionStatus: data.codiceStato,
    signedBy: '',
    competentUnit: data.codiceAmbito || '',
    assignedTo: '',
    attachments: data.allegati?.map((el) => ({
      name: el.nomeFile || '',
      raw: el.contenutoAllegato || '',
      tipoAllegato: el.mimeType || '',
      type: el.tipoFile || '',
    })) as Array<TypeFile>,
    messageNumber: data.key?.idComunicazione,
    trasmissionStyleObject: {
      color: 'primary',
      label: '',
    },
  };
};
